var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.442,
    height: 20.383,
    viewBox: "0 0 21.442 20.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-event-1826631",
    transform: "translate(-109.522 -51.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37467",
    "data-name": "Path 37467",
    d: "M110.941,179.257h8.144a6.511,6.511,0,0,1,9.273-7.3v-3.827H109.522v9.7a1.421,1.421,0,0,0,1.419,1.419Z",
    transform: "translate(0 -111.525)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37468",
    "data-name": "Path 37468",
    d: "M128.364,53.976a1.421,1.421,0,0,0-1.419-1.419h-1.078v-.664a.488.488,0,0,0-.975,0v.664H113v-.664a.488.488,0,0,0-.975,0v.664h-1.078a1.421,1.421,0,0,0-1.419,1.419v1.658h18.836Z",
    transform: "translate(-0.006 0)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37469",
    "data-name": "Path 37469",
    d: "M342.08,265.727a5.537,5.537,0,1,0,5.537-5.537A5.543,5.543,0,0,0,342.08,265.727Zm7.6.125a.488.488,0,0,1,0,.975h-2.443a.488.488,0,0,1-.488-.488v-3.257a.488.488,0,0,1,.975,0v2.769Z",
    transform: "translate(-222.19 -199.477)",
    fill: "#61277f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarEvent);
export default __webpack_public_path__ + "static/media/sidebar-event.5be9dfa7b0998b0464ffd528106321ad.svg";
export { ForwardRef as ReactComponent };